import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, Transition as _Transition, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "c-popup__inner" }
const _hoisted_2 = { class: "c-popup__header" }
const _hoisted_3 = { class: "c-popup__title" }
const _hoisted_4 = { class: "c-popup__body p-[30px] text-center" }
const _hoisted_5 = { class: "text-[16px]" }
const _hoisted_6 = { class: "c-popup__footer" }

import { ref, onMounted, onBeforeUnmount } from 'vue';
import BaseButton from '@/components/BaseButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Alert',
  props: {
  modelValue: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: '',
  },
  desc: {
    type: String,
    default: 'title',
  },
  confirmText: {
    type: String,
    default: '확인',
  },
  closeText: {
    type: String,
    default: '취소',
  },
  showClose: {
    type: Boolean,
    default: true,
  },
  onClose: Function,
  onConfirm: Function,
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;
const closePopup = () => {
  emit('update:modelValue', false);
  if (props.onClose) {
    props.onClose();
  }
};
const confirm = () => {
  emit('update:modelValue', false);
  if (props.onConfirm) {
    props.onConfirm();
  }
  if (props.onClose) {
    props.onClose();
  }
};
// check device
const isMobile = ref(true);

const checkIsMobile = () => {
  isMobile.value = window.innerWidth < 767;
  console.log('isMobile:', isMobile.value);
}

onMounted(() => {
  checkIsMobile();
  window.addEventListener('resize', checkIsMobile);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', checkIsMobile);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (__props.modelValue)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(`c-popup ${isMobile.value ? 'mo':''}`)
          }, [
            _createElementVNode("div", {
              type: "button",
              class: "c-popup__dim",
              onClick: closePopup
            }),
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(__props.title), 1),
                (__props.showClose)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      onClick: closePopup
                    }, _cache[0] || (_cache[0] = [
                      _createElementVNode("i", { class: "c-icon c-icon--close" }, [
                        _createElementVNode("span", { class: "s-hide" }, "close")
                      ], -1)
                    ])))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("p", _hoisted_5, _toDisplayString(__props.desc), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(BaseButton, {
                  color: "outline",
                  size: "small",
                  onClick: closePopup
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.closeText), 1)
                  ]),
                  _: 1
                }),
                _createVNode(BaseButton, {
                  size: "small",
                  onClick: confirm
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.confirmText), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})